const THREE = require('three');

export default function cam () {
  this.camera = new THREE.PerspectiveCamera( 30, 1, 0.1, 1000 )
  this.camera.position.set( 0, -2, 4.5 );
  this.camera.lookAt( 0, 0.5 );
  return this.camera
}
